<div class="rd-widget rd-widget-no-height-restriction widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <!--tax-->
  <table class="widget-large" aria-hidden="true">
    <thead>
      <tr>
        <ng-container *ngIf="editMode">
          <th scope="col" class="widget-grid-column">
            <span class="k-icon k-i-minus" (click)="deleteCurrentRow(rowsTax, 'tax')"></span>
            <span class="k-icon k-i-plus" (click)="addRow(rowsTax, 'tax')" *ngIf="sectionHasAvailableFields('countrySpecifics-tax')"></span>
            <span class="k-icon k-i-arrow-up" (click)="moveCurrentRowUp(rowsTax, 'tax')"></span>
            <span class="k-icon k-i-arrow-down" (click)="moveCurrentRowDown(rowsTax, 'tax')"></span>
          </th>
        </ng-container>
        <th scope="col" class="widget-grid-column">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true">{{'countrySpecifics.labelTaxTitle' | rdTranslate}}</widget-value>
        </th>
        <ng-container *ngIf="!editMode">
          <th scope="col" class="widget-grid-column">
            &nbsp;
          </th>
        </ng-container>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody>

      <rd-textandlist-section [widget]="this"[widgetId]="this.widgetConfig.widgetId" [page]="page" [selectedTag]="hashTag" [sectionName]="textAndListSectionNameTax" [disableCustomLabels]="disableCustomLabels" [reflists]="reflists" [topicReflist]="'ref_l3_country_specifics_tax'"
                              [editMode]="editMode" [rows]="rowsTax" [leftColspan]="6" [rightColspan]="6" [data]="widgetData.tax"
                              [alternatingColorScheme]="true" [currency]="currency" [unitOfArea]="unitOfArea" [addRow]="addRowTax$"
                              [deleteCurrentRow]="deleteCurrentRow$" [moveCurrentRowUp]="moveCurrentRowUp$"
                              [moveCurrentRowDown]="moveCurrentRowDown$" (dataChanged)="onDataChanged()"
                              (sectionRowsCountChanged)="sectionRowsCountChanged($event)">
      </rd-textandlist-section>
    </tbody>
  </table>
  <div class="space-part">&nbsp;</div>
  <div class="space-part">&nbsp;</div>
  <div class="space-part">&nbsp;</div>

  <!--last sale-->
  <table class="widget-large" aria-hidden="true" [hidden]="hideLastSaleSection">
    <thead>
      <tr>
        <ng-container *ngIf="editMode">
          <th scope="col" class="widget-grid-column">
            <span class="k-icon k-i-minus" (click)="deleteCurrentRow(rowsLastSale, 'sale')"></span>
            <span class="k-icon k-i-plus" (click)="addRow(rowsLastSale, 'sale')" *ngIf="sectionHasAvailableFields('countrySpecifics-lastsale')"></span>
            <span class="k-icon k-i-arrow-up" (click)="moveCurrentRowUp(rowsLastSale, 'sale')"></span>
            <span class="k-icon k-i-arrow-down" (click)="moveCurrentRowDown(rowsLastSale, 'sale')"></span>
          </th>
        </ng-container>
        <th scope="col" colspan="3" class="widget-grid-column">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true">{{'countrySpecifics.labelLastSaleTitle' | rdTranslate}}</widget-value>
        </th>
        <ng-container *ngIf="!editMode">
          <th scope="col" class="widget-grid-column">
            &nbsp;
          </th>
        </ng-container>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <rd-textandlist-section [widget]="this" [widgetId]="this.widgetConfig.widgetId" [page]="page" [selectedTag]="hashTag" [sectionName]="textAndListSectionNameLastSale" [disableCustomLabels]="disableCustomLabels" [reflists]="reflists" [topicReflist]="'ref_l3_country_specifics_last_sale'"
                              [editMode]="editMode" [rows]="rowsLastSale" [leftColspan]="6" [rightColspan]="6"
                              [data]="widgetData.lastSale" [alternatingColorScheme]="true" [currency]="currency"
                              [unitOfArea]="unitOfArea" [addRow]="addRowLastSale$" [deleteCurrentRow]="deleteCurrentRowLastSale$"
                              [moveCurrentRowUp]="moveCurrentRowUpLastSale$" [moveCurrentRowDown]="moveCurrentRowDownLastSale$"
                              (dataChanged)="onDataChanged()"
                              (sectionRowsCountChanged)="sectionRowsCountChanged($event)">
      </rd-textandlist-section>
    </tbody>
  </table>
  <div class="space-part" [hidden]="hideLastSaleSection">&nbsp;</div>
  <div class="space-part" [hidden]="hideLastSaleSection">&nbsp;</div>
  <div class="space-part" [hidden]="hideLastSaleSection">&nbsp;</div>

  <!--use-->
  <table class="widget-large" aria-hidden="true" [hidden]="hideUseSection">
    <thead>
      <tr>
        <ng-container *ngIf="editMode">
          <th scope="col" class="widget-grid-column">
            <span class="k-icon k-i-minus" (click)="deleteCurrentRow(rowsUse, 'use')"></span>
            <span class="k-icon k-i-plus" (click)="addRow(rowsUse, 'use')" *ngIf="sectionHasAvailableFields('countrySpecifics-use')"></span>
            <span class="k-icon k-i-arrow-up" (click)="moveCurrentRowUp(rowsUse, 'use')"></span>
            <span class="k-icon k-i-arrow-down" (click)="moveCurrentRowDown(rowsUse, 'use')"></span>
          </th>
        </ng-container>
        <th scope="col" colspan="7" class="widget-grid-column">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true">{{'countrySpecifics.labelUseTitle' | rdTranslate}}</widget-value>
        </th>
        <ng-container *ngIf="!editMode">
          <th scope="col" class="widget-grid-column">
            &nbsp;
          </th>
        </ng-container>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <rd-textandlist-section [widget]="this" [widgetId]="this.widgetConfig.widgetId" [page]="page" [selectedTag]="hashTag" [sectionName]="textAndListSectionNameUse" [disableCustomLabels]="disableCustomLabels" [reflists]="reflists" [topicReflist]="'ref_l3_country_specifics_use'"
                              [editMode]="editMode" [rows]="rowsUse" [leftColspan]="6" [rightColspan]="6" [data]="widgetData.use"
                              [alternatingColorScheme]="true" [currency]="currency" [unitOfArea]="unitOfArea" [addRow]="addRowUse$"
                              [deleteCurrentRow]="deleteCurrentRowUse$" [moveCurrentRowUp]="moveCurrentRowUpUse$"
                              [moveCurrentRowDown]="moveCurrentRowDownUse$" (dataChanged)="onDataChanged()"
                              (sectionRowsCountChanged)="sectionRowsCountChanged($event)">
      </rd-textandlist-section>
    </tbody>
  </table>
  <div class="space-part" [hidden]="hideUseSection">&nbsp;</div>
  <div class="space-part" [hidden]="hideUseSection">&nbsp;</div>
  <div class="space-part" [hidden]="hideUseSection">&nbsp;</div>

  <!--last appraisal-->
  <table class="widget-large" aria-hidden="true" *ngIf="widgetData.previousAppraisal">
    <thead>
      <tr>
        <th colspan="4" scope="col">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true">{{'countrySpecifics.labelPreviousAppraisalTitle' | rdTranslate}}</widget-value>
        </th>
      </tr>
      <tr class="red-line widget-ruller-large">
        <th scope="col">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true">
            {{'countrySpecifics.labelDateOfPreviousValuation' | rdTranslate}}
          </widget-value>
        </th>
        <th scope="col">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true">DDMMYYYY</widget-value>
        </th>
        <th scope="col">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true">DDMMYYYY</widget-value>
        </th>
        <th scope="col">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true">DDMMYYYY</widget-value>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="widgetData.previousAppraisal.financialSummary">
        <td colspan="1">
          <widget-label [widget]="this" [fieldName]="'labelFinancialSummary'" [align]="'left'"></widget-label>
        </td>
        <td *ngIf="editMode" colspan="1">
          <pollux-report-designer-date-field class="widget-input-text" ngDefaultControl
                                             [(ngModel)]="widgetData.previousAppraisal.financialSummary.date1" (ngModelChange)="setDirtyFlag(true)">
          </pollux-report-designer-date-field>
        </td>
        <td *ngIf="!editMode" colspan="1">
          <widget-value [align]="'right'">
            {{widgetData.previousAppraisal.financialSummary.date1 | rdLocalizedDate}}
          </widget-value>
        </td>
        <td *ngIf="editMode" colspan="1">
          <pollux-report-designer-date-field class="widget-input-text" ngDefaultControl
                                             [(ngModel)]="widgetData.previousAppraisal.financialSummary.date2" (ngModelChange)="setDirtyFlag(true)">
          </pollux-report-designer-date-field>
        </td>
        <td *ngIf="!editMode" colspan="1">
          <widget-value [align]="'right'">
            {{widgetData.previousAppraisal.financialSummary.date2 | rdLocalizedDate}}
          </widget-value>
        </td>
        <td *ngIf="editMode" colspan="1">
          <pollux-report-designer-date-field class="widget-input-text" ngDefaultControl
                                             [(ngModel)]="widgetData.previousAppraisal.financialSummary.date3" (ngModelChange)="setDirtyFlag(true)">
          </pollux-report-designer-date-field>

        </td>
        <td *ngIf="!editMode" colspan="1">
          <widget-value [align]="'right'">
            {{widgetData.previousAppraisal.financialSummary.date3 | rdLocalizedDate}}
          </widget-value>
        </td>
      </tr>
      <tr>
        <td colspan="1">
          <widget-label [widget]="this" [fieldName]="'labelCopex'" [align]="'left'"></widget-label>
        </td>
        <td *ngIf="editMode" colspan="1">
          <pollux-report-designer-date-field class="widget-input-text" ngDefaultControl
                                             [(ngModel)]="widgetData.previousAppraisal.copex.date1" (ngModelChange)="setDirtyFlag(true)">
          </pollux-report-designer-date-field>
        </td>
        <td *ngIf="!editMode" colspan="1">
          <widget-value [align]="'right'">{{widgetData.previousAppraisal.copex.date1 | rdLocalizedDate}}</widget-value>
        </td>
        <td *ngIf="editMode" colspan="1">
          <pollux-report-designer-date-field class="widget-input-text" ngDefaultControl
                                             [(ngModel)]="widgetData.previousAppraisal.copex.date2" (ngModelChange)="setDirtyFlag(true)">
          </pollux-report-designer-date-field>
        </td>
        <td *ngIf="!editMode" colspan="1">
          <widget-value [align]="'right'">{{widgetData.previousAppraisal.copex.date2 | rdLocalizedDate}}</widget-value>
        </td>
        <td *ngIf="editMode" colspan="1">
          <pollux-report-designer-date-field class="widget-input-text" ngDefaultControl
                                             [(ngModel)]="widgetData.previousAppraisal.copex.date3" (ngModelChange)="setDirtyFlag(true)">
          </pollux-report-designer-date-field>
        </td>
        <td *ngIf="!editMode" colspan="1">
          <widget-value [align]="'right'">{{widgetData.previousAppraisal.copex.date3 | rdLocalizedDate}}</widget-value>
        </td>
      </tr>
      <tr>
        <td colspan="1">
          <widget-label [widget]="this" [fieldName]="'labelValuationResults'" [align]="'left'"></widget-label>
        </td>
        <td *ngIf="editMode" colspan="1">
          <pollux-report-designer-date-field class="widget-input-text" ngDefaultControl
                                             [(ngModel)]="widgetData.previousAppraisal.valuationResults.date1"
                                             (ngModelChange)="setDirtyFlag(true)"></pollux-report-designer-date-field>
        </td>
        <td *ngIf="!editMode" colspan="1">
          <widget-value [align]="'right'">
            {{widgetData.previousAppraisal.valuationResults.date1 | rdLocalizedDate}}
          </widget-value>
        </td>
        <td *ngIf="editMode" colspan="1">
          <pollux-report-designer-date-field class="widget-input-text" ngDefaultControl
                                             [(ngModel)]="widgetData.previousAppraisal.valuationResults.date2"
                                             (ngModelChange)="setDirtyFlag(true)"></pollux-report-designer-date-field>
        </td>
        <td *ngIf="!editMode" colspan="1">
          <widget-value [align]="'right'">
            {{widgetData.previousAppraisal.valuationResults.date2 | rdLocalizedDate}}
          </widget-value>
        </td>
        <td *ngIf="editMode" colspan="1">
          <pollux-report-designer-date-field class="widget-input-text" ngDefaultControl
                                             [(ngModel)]="widgetData.previousAppraisal.valuationResults.date3"
                                             (ngModelChange)="setDirtyFlag(true)"></pollux-report-designer-date-field>
        </td>
        <td *ngIf="!editMode" colspan="1">
          <widget-value [align]="'right'">
            {{widgetData.previousAppraisal.valuationResults.date3 | rdLocalizedDate}}
          </widget-value>
        </td>
      </tr>
      <tr>
        <td colspan="1">
          <widget-label [widget]="this" [fieldName]="'labelBreakdown'" [align]="'left'"></widget-label>
        </td>
        <td *ngIf="editMode" colspan="1">
          <pollux-report-designer-date-field class="widget-input-text" ngDefaultControl
                                             [(ngModel)]="widgetData.previousAppraisal.breakdown.date1"
                                             (ngModelChange)="setDirtyFlag(true)"></pollux-report-designer-date-field>
        </td>
        <td *ngIf="!editMode" colspan="1">
          <widget-value [align]="'right'">{{widgetData.previousAppraisal.breakdown.date1 | rdLocalizedDate}}</widget-value>
        </td>
        <td *ngIf="editMode" colspan="1">
          <pollux-report-designer-date-field class="widget-input-text" ngDefaultControl
                                             [(ngModel)]="widgetData.previousAppraisal.breakdown.date2"
                                             (ngModelChange)="setDirtyFlag(true)"></pollux-report-designer-date-field>
        </td>
        <td *ngIf="!editMode" colspan="1">
          <widget-value [align]="'right'">{{widgetData.previousAppraisal.breakdown.date2 | rdLocalizedDate}}</widget-value>
        </td>
        <td *ngIf="editMode" colspan="1">
          <pollux-report-designer-date-field class="widget-input-text" ngDefaultControl
                                             [(ngModel)]="widgetData.previousAppraisal.breakdown.date3"
                                             (ngModelChange)="setDirtyFlag(true)"></pollux-report-designer-date-field>
        </td>
        <td *ngIf="!editMode" colspan="1">
          <widget-value [align]="'right'">{{widgetData.previousAppraisal.breakdown.date3 | rdLocalizedDate}}</widget-value>
        </td>
      </tr>
    </tbody>
  </table>
</div>
